import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
//import LockOutlinedIcon from '@mui/icons-material/Avatar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { client, AUTH_USER, getUsers, whoami, UPDATE_USER, CREATE_USER, getCategories, getCompanies, AI_URL_COMPANY_FEEDBACK, filterCompany } from '../graphqlClient/graphql'
import SimpleAlert from './../components/Alert/Alert'
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import Notifications from './../components/notifications/Notifications';
import { useNavigate } from 'react-router-dom'
import { Autocomplete, LinearProgress } from '@mui/material';
import logo_centro from './../assets/images/login/logo_wescout.png'
import background from './../assets/images/sign/background_sign.png'
import texto from './../assets/images/sign/text_sign.png'
import globo from './../assets/images/sign/globo.png'
function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://wescout.me">
        wwww.wescout.me
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

const SignUpPage = () => {
  const params = useParams<{ type: string }>()
  const navigate = useNavigate()
  const commonDomains = ['gmail', 'hotmail', 'outlook', 'yahoo', 'aol', 'live'];
  console.log('params ==> ', params)
  const [type, setType] = React.useState<any>('scout');//scouter or scout
  const [corporateEmail, setCorporateEmail] = React.useState<any>(false);
  const [email, setEmail] = React.useState<any>('');
  const [message, setMessage] = React.useState<any>('Please wait. Your account is being created.');
  const [loading, setLoading] = React.useState<any>(false);
  const [categories, setCategories] = React.useState<any>([]);
  const [companies, setCompanies] = React.useState<any>([]);
  const [selectedCategory, setSelectedCategory] = React.useState<any>({});
  const [selectedCompany, setSelectedCompany] = React.useState<any>({});
  const [CreateUserMutation, { data }] = useMutation(CREATE_USER);
  //AI_URL_COMPANY_FEEDBACK
  const [AiUrlFeedback, { data: aiUrl }] = useMutation(AI_URL_COMPANY_FEEDBACK);
  console.log('signup', type)

  const checkCompany = async () => {

    setMessage('Linking company...')

    const objToSend = {
      domain: email,
    }
    if (!email || email.length < 4) {
      const notData = {
        type: 'error',
        message: 'Please provide a valid email address',
        title: 'wescout',
        timeOut: 1000,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      return null;
    }
    //setIsLoadingCompaniesByFilter(true)
    console.log('objToSend', objToSend)

    const result = await filterCompany(objToSend)
    console.log('filter result ==>>', result)
    if (result.length) {
      return result[0]
    } else {
      return null
    }
  }

  const sendMessage = async (usuario: { _id: any; }) => {
    setLoading(true);
    if (!usuario) {
      const notData = {
        type: 'error',
        message: 'User not found',
        title: 'wescout',
        timeOut: 1000,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      setLoading(false);
      return;
    }
    if (!email || email.length < 4) {
      const notData = {
        type: 'error',
        message: 'E-mail incomplete',
        title: 'wescout',
        timeOut: 1000,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      setLoading(false);
      return;
    }
    const message = email
    const createChatgptInput: any = {
      user: usuario._id,
      message,
      type: 'aiurlfeedback',
    }

    delete createChatgptInput.__typename
    console.log('createChatgptInput', createChatgptInput)

    setLoading(true)
    try {
      const userToken = await AiUrlFeedback({
        variables: {
          createChatgptInput: createChatgptInput,

        },
        onCompleted: ({ aiurlCompanyfeedback }) => {
          setMessage('finishing...')
          console.log('aiurlCompanyfeedback result== > ', aiurlCompanyfeedback);
          /* const notData = {
              type: 'success',
              message: 'Your resume has been successfully reviewed',
              title: 'wescout',
              timeOut: 1500,
              callback: () => { },
              priority: true,
          }
          Notifications(notData) */
          let res = aiurlCompanyfeedback.response
          console.log('res', res)
          if (res == 'No response received from the assistant.') {
            const notData = {
              type: 'error',
              message: 'No response received from the assistant',
              title: 'wescout',
              timeOut: 1000,
              callback: () => { },
              priority: true,
            }
            Notifications(notData)
            setLoading(false)
            return;
          }
          //console.log("type", typeof res)
          if (typeof res == 'string') {
            res = JSON.parse(res)
          }
          const notData = {
            type: 'success',
            message: `User created successfully!`,
            title: 'wescout',
            timeOut: 2000,
            callback: () => { },
            priority: true,
          }
          Notifications(notData)
          navigate('/login')
          setLoading(false);


          //setChatgpt(aiurlresumefeedback)
          //getChatgptAsync(usuario)



        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      console.log("Erro ao atualizar usuário", error)
      setLoading(false)
    }
  }


  const getCategoriesAsync = async () => {

    const result: any = await getCategories()
    console.log('resutl ===>', result)

    if (result?.length) {
      setCategories(result)
    }
  }

  const getCompaniesAsync = async () => {

    const result: any = await getCompanies()
    console.log('resutlgetCompanies ===>', result)

    if (result?.length) {
      setCompanies(result)
    }
  }

  React.useEffect(() => {
    ///getUsuarios();
    getCategoriesAsync();
    getCompaniesAsync();
  }, []);
  React.useEffect(() => {
    ///getUsuarios();
    //getCategoriesAsync();
    //getCompaniesAsync();
    if (params?.type != '' && params?.type != 'scout') {
      setType(params?.type)
    }

  }, [params]);

  const isCorporateEmail = (text: any) => {
    console.log('isCorporateEmail', text)
    if (!text.indexOf('@') || !text.indexOf('.')) {
      setCorporateEmail(false)
      return false;
    }
    const domainPart = text?.split('@')[1]
    const domain = domainPart?.split('.')[0];
    console.log('domain ', domain)
    const res = commonDomains.includes(domain)
    console.log('res ==> ', res)
    if (!res && domainPart) {
      setEmail(domainPart.split('/')[0])
    }
    setCorporateEmail(res)
    return res;
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    //console.log('data ==>', data)

    console.log({
      email: data.get('email'),
      password: data.get('password'),
      confirmPassword: data.get('password'),
      name: data.get('firstName') + ' ' + data.get('lastName'),


    });

    const company = await checkCompany();
    console.log(company)

    try {
      const createUserInput: any = {

        email: data.get('email'),
        password: data.get('password'),
        confirmPassword: data.get('password'),
        name: data.get('firstName') + ' ' + data.get('lastName'),
        category: selectedCategory?._id || null,
        role: type,
        //company: selectedCategory || null,

      }
      if (company) {
        createUserInput.company = company._id;
        console.log('createUserInput', createUserInput)
        setLoading(true);
        const result = await CreateUserMutation({
          variables: {
            createUserInput
          },
          onCompleted: ({ createUser }) => {

            console.log('user created== > ', createUser);

            //setLoading(false);
            if (!company) {
              sendMessage(createUser)
            } else {
              const notData = {
                type: 'success',
                message: `User ${createUser?.name} Created Successfully!`,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
              }
              Notifications(notData)
              navigate('/login')
              setLoading(false);
              return;
            }


            //setUsuario(updateUser);
          }
        });

      } else {


      }

    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      setLoading(false);
      console.log("Erro ao criar usuário", error.message)

    }



  };

  const handleButtonClick = (button: any) => { setType(button); };

  return (
    <ThemeProvider theme={defaultTheme}>

      <div style={{
        display: 'flex',
        width: '100%',
        maxHeight: '100vh',
        backgroundColor: 'transparent',
        justifyContent: 'space-between',
        overflow: 'hidden'
      }}>
        <CssBaseline />

        <div className={'leftContent'}>
          <div className={'imgBackgroundContainer'}>
            <img className={'imgBackground'} src={background} alt="" />
            <img className={'imgTexto'} src={texto} alt="" />
            <img className={'imgGlobo'} src={globo} alt="" />
          </div>
          {/*  */}
        </div>
        <div className={'rightContent'}>
          {loading ?
            (
              <Box sx={{ width: '100%' }}>
                <Typography style={{ margin: '10px' }}  >{message}
                </Typography>
                <LinearProgress />
              </Box>
            ) : null}


          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

            <Typography style={{ fontWeight: 'bold' }} variant="h5" component="div">
              Create an account
            </Typography>
            <Typography style={{ fontWeight: 'normal', margin: 10 }} >
              Your gateway to a curated pool of talent<br></br>
              recommended by those who know them best
            </Typography>
            {/* <Typography  style={{fontWeight:'normal'}} variant="h6" component="div">
              Choose your perfil 
            </Typography> */}

            <Box sx={{
              minWidth: '90%',
              margin: '10px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}>
              <Button variant='text' className={type === 'scout' ? 'selected' : ''} onClick={() => handleButtonClick('scout')}>Scout me</Button>
              <Button variant='text' className={type === 'scouter' ? 'selected' : ''} onClick={() => handleButtonClick('scouter')}>Scout</Button>
            </Box>

            {type === 'scout' ?
              <Typography style={{ fontWeight: 'bold', textAlign: 'center' }} component="div">
                Request a referral now
              </Typography>
              :
              <Typography style={{ fontWeight: 'bold', textAlign: 'center' }} component="div">
                Get in to your company´s referral program and get paid
              </Typography>
            }




            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="given-name"
                    name="firstName"
                    required
                    fullWidth
                    id="firstName"
                    label="First Name"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="family-name"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    onChange={(e: any) => {
                      if (type === 'scouter') isCorporateEmail(e.target.value)
                    }}
                    helperText={type === 'scout' ? 'Please enter your best e-mail' : 'Please enter your corporate e-mail'}
                    error={corporateEmail}
                    id="email"
                    label="E-mail Address"
                    name="email"
                    autoComplete="email"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="new-password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    name="cpassword"
                    label="Confirm Password"
                    type="password"
                    id="cpassword"
                    autoComplete="new-password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ width: '100%' }} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', height: 50, alignContent: 'center', justifyContent: 'space-around', alignSelf: 'center', borderColor: 'green', borderWidth: 2 }}>
                    <Autocomplete
                      getOptionLabel={(cat: any) => cat.name}
                      //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                      onChange={(event, newValue) => {
                        console.log(newValue)
                        if (!newValue) {
                          setSelectedCategory({})
                          //changeCategory({})

                        }
                        setSelectedCategory(newValue)
                        //changeCategory(newValue)
                        //getInventoriesByCategory(newValue._id)
                      }}
                      disablePortal
                      id="combo-box-demo"
                      options={categories}
                      sx={{ width: '100%' }}
                      renderInput={(params: any) => <TextField {...params} label="Category" />}
                    />


                  </Box>
                </Grid>
                {/* <Grid item xs={12}>
                  <TextField

                    fullWidth
                    name="linkedIn"
                    label="LinkedIn Profile"
                    type="link"
                    id="linkedIn"
                    autoComplete="LinkedIn"
                  />
                </Grid> */}
                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox value="allowExtraEmails" color="primary" />}
                    label="I want to receive news, promotional materials and updates by e-mail."
                  />
                </Grid>
              </Grid>

              <Button
                disabled={loading}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                create account
              </Button>




            </Box>
            Already have an account?
            <Link href="/login" variant="h6">
              sign in
            </Link>
          </Box>
        </div>
        {/* <Copyright sx={{ mt: 5 }} /> */}
      </div>
    </ThemeProvider>
  );
}

export default SignUpPage